import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export type ProgramAuditQueueConfig = {
  enabled: boolean
  type?: 'rate' | 'weighted'
  perMsRate?: number
  perMsMaxCount?: number
}

export type ProgramBenchmarkSuperMajorityConfig = {
  enabled: boolean
  superMajorityProgramId: string | null
  minimumTotalVotes: number
  agreementRatio: number
  maximumTotalVotes: number
}

export type ProgramBenchmarkSettingsResponse = ProgramAuditQueueConfig & {
  superMajority?: ProgramBenchmarkSuperMajorityConfig
}

export const PROGRAM_AUDIT_KEY = 'program-audit'
export const PROGRAM_AUDIT_VOIDERS_KEY = 'program-audit-voiders'

export const useGetById = (programId?: string) => {
  return useQuery({
    queryKey: [PROGRAM_AUDIT_KEY, programId],
    queryFn: async () => {
      const response = await apiClient.get<ProgramBenchmarkSettingsResponse>(
        `/int/v3/programs/${programId}/config/benchmark`
      )
      return response.data
    },
    enabled: Boolean(programId),
  })
}

export const useGetVoiderList = (programId?: string) => {
  return useQuery({
    queryKey: [PROGRAM_AUDIT_VOIDERS_KEY, programId],
    queryFn: async () => {
      const response = await apiClient.get<{ auditVoiders: { id: string; name: string }[] }>(
        `/int/v3/programs/${programId}/audit-voiders`
      )
      return response.data.auditVoiders
    },
    enabled: Boolean(programId),
  })
}
